/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 07/05/2025 17:34
 *
 */

import {
  Component,
  computed,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  signal,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  ActionEvent,
  StandardAction,
  Style,
} from '@infodata-group/inf-commons';
import { AoPath } from '../../model/path/ao-path';

@Component({
  selector: 'ao-shared-path-player',
  standalone: true,
  imports: [],
  templateUrl: './path-player.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './path-player.component.scss',
})
export class PathPlayerComponent {
  public intervalValue = 250;
  protected interval: number;
  protected readonly Style = Style;
  protected status: 'playing' | 'paused' = 'paused';

  protected currentPosition = signal(0);
  protected progress = computed(() => {
    this.playEvent.emit(
      new ActionEvent(
        'select',
        new StandardAction('next', ''),
        this.currentPosition(),
      ),
    );
    return (this.currentPosition() / this.path.polyline.length) * 100;
  });
  protected infoWindowText = computed(() => {
    const point = this.path.polyline
      .at(this.currentPosition() - 1)
      .points.at(-1);
    return this.path.pathPoint.find((p) => p.getId() === point.id).heureDebut;
  });
  protected startTime = computed(() => {
    return this.path.pathPoint.at(0).heureDebut;
  });
  protected endTime = computed(() => {
    return this.path.pathPoint.at(-1).heureDebut;
  });

  @Input({ required: true }) path: AoPath;

  @ViewChild('globalProgressBar') globalProgressBar: ElementRef<HTMLDivElement>;

  @Output() playEvent = new EventEmitter<ActionEvent>();

  public play() {
    if (this.currentPosition() === this.path.polyline.length) {
      this.intervalValue = 0;
      this.currentPosition.set(0);
      setTimeout(() => {
        this.intervalValue = 250;
        this.play();
      }, 50);
      return;
    }
    this.status = 'playing';
    this.interval = setInterval(() => {
      if (this.currentPosition() <= this.path.polyline.length - 1) {
        this.currentPosition.set(this.currentPosition() + 1);
        return;
      }
      this.pause();
    }, this.intervalValue);
  }

  public pause() {
    this.status = 'paused';
    clearInterval(this.interval);
  }

  public updateStatus() {
    if (this.status === 'playing') {
      this.pause();
      return;
    }
    this.play();
  }

  public onClickProgressBar($event: MouseEvent) {
    this.currentPosition.set(this.getCurrentPositionByPosition($event.offsetX));
  }

  private getCurrentPositionByPosition(offsetX: number): number {
    const position = Math.round(
      (this.path.polyline.length - 1) *
        (offsetX / this.globalProgressBar.nativeElement.offsetWidth),
    );
    return position;
  }
}
